const colors = {
  WHITE: 0xFAFAFA,
  BLACK: 0x111D1D,
  GOLD: 0xF6A800,

  ACCENT: 0xFBE8DD,

  RED: 0x770724,
  RED_LIGHT: 0x914641,

  PINK: 0xE0A3A6,
  PINK_LIGHT: 0xFBE8DD,

  GREEN: 0x2B3C09,
  GREEN_DARK: 0x111D1D,
  GREEN_LIGHT: 0x535E1F,
  GREEN_EXTRA_LIGHT: 0x648627,
};

export default colors;
